import { Component, Input, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { OrcadentTreatmentPackages, TreatmentPackages } from "libs/treatments/src/lib/models";
import { ProfessionalPackagesService } from "libs/treatments/src/lib/services";


@Component({
	selector: "ux-packages-preview",
	standalone: true,
	imports: [CommonModule],
	templateUrl: "./packages-preview.component.html",
	styleUrl: "./packages-preview.component.scss"
})
export class PackagesPreviewComponent implements OnInit {

	@Input({required: true}) packages: TreatmentPackages | OrcadentTreatmentPackages;
	readonly maxShownPackages = 8;

	isProfessionalPackage: boolean = false;
	totalProfessionalPackages: number = 0;

	constructor(){}

	ngOnInit(): void {
		this.isProfessionalPackage = 'steps' in this.packages;
		if(this.isProfessionalPackage){
			this.totalProfessionalPackages = ProfessionalPackagesService.getTotalPackageCount(this.getProfessionalPackages());
		}
	}

	protected getProfessionalPackages(){
		return this.packages as TreatmentPackages;
	}

	protected getOrcadentPackages(){
		return this.packages as OrcadentTreatmentPackages;
	}
}
